import { render } from "./ApiContainer.vue?vue&type=template&id=620a62f1"
import script from "./ApiContainer.vue?vue&type=script&lang=js"
export * from "./ApiContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__